import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["destroyField", "row"];

  remove(event) {
    event.preventDefault();

    // Find the hidden _destroy field (either as a target or by searching)
    const destroyField =
      this.hasDestroyFieldTarget
        ? this.destroyFieldTarget
        : this.element.querySelector('input[type="hidden"][name*="[_destroy]"]');

    // Get the row to hide/remove
    const row = this.hasRowTarget ? this.rowTarget : this.element;

    if (destroyField) {
      // Mark for destruction and hide
      destroyField.value = "1";
      row.style.display = "none";
    } else {
      // No destroy field found - just remove from DOM (new record)
      row.remove();
    }
  }
}
